import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function WorkshopForWho() {
  const forWho = ['Oameni care simt că viața lor poate fi mai bună, dar se lovesc mereu de aceleași tipare și nu înțeleg de ce se blochează în același punct.', 'Oameni care au o relație dificilă cu banii și simt că abundența vine greu spre ei. Vor să înțeleagă ce se întâmplă la nivel de subconștient.', 'Oameni curioși despre dezvoltare personală și spiritualitate care vor să experimenteze concret o meditație ghidată și lucrul cu credințele limitative.'];
  const notForWho = ['Cei care caută soluții rapide și miraculoase. Acest workshop îți oferă un prim pas real, nu o pastilă magică.', 'Cei complet sceptici față de meditație, lucru cu subconștientul sau dimensiunea spirituală. Dacă nu ai deschidere, nu vei rezona.', 'Cei care vor doar să asculte pasiv fără să participe. Workshop-ul include o meditație și un exercițiu practic — funcționează doar dacă te implici.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-2202">
      <div className="max-w-6xl mx-auto px-6" data-id="element-2203">
        <SectionHeading title="Pentru cine este acest workshop" data-id="element-2204" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-2205">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-2206">
            <div className="flex items-center gap-4 mb-8" data-id="element-2207">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2208">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-2209" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-2210">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-2211">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-2212">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-2213" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-2214">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-2215">
            <div className="flex items-center gap-4 mb-8" data-id="element-2216">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2217">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-2218" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-2219">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-2220">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-2221">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-2222" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-2223">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2224">
          <CTAButton data-id="element-2225" />
        </motion.div>
      </div>
    </section>;
}